import { NotificationType } from './../notification.model';
import { PagedRequestDto } from '../paged-request.model';

export interface NotificationSearchDto extends PagedRequestDto {
  isRead?: boolean;
  notificationType?: NotificationType;
}
